export const getPercentDifference = (percentage: number, precision = 2): number =>
  parseFloat((100 - (percentage ?? 0)).toFixed(precision))
